/* Generated by restful-react */

import React from 'react'
import { Get, GetProps, useGet, UseGetProps } from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface ShipperStrikePricesFilters {
  shipperApplicationId?: number
}

export interface ShipperStrikePricesResponse {
  shipperStrikePrices?: ShipperStrikePrices[]
}

export interface ShipperStrikePrices {
  id?: number
  shipperApplicationId: number
  region: 'Midwest' | 'Coastal' | 'Southeast' | 'Northeast' | 'South' | 'West'
  isShorthaul: boolean
  isDefault: boolean
  equipment: {
    parentId: number
  }
  strikePrice: number | null
  costAssumption: number | null
  marginPercentage: number | null
  winPercentage: number | null
  forecastedAt: string | null
  manualOverride: ShipperStrikePriceOverride
}

export type ShipperStrikePriceOverride = {
  id: number
  shipperStrikePriceId: number
  overridePercentage: number
  reason: string
  updatedById: number
  startAt: string
  endAt: string
} | null

export interface GetShipperStrikePricesQueryParams {
  /**
   * Filters
   */
  filters?: ShipperStrikePricesFilters
}

export type GetShipperStrikePricesProps = Omit<
  GetProps<ShipperStrikePricesResponse, unknown, GetShipperStrikePricesQueryParams, void>,
  'path'
>

/**
 * Get all shipper strike price data
 */
export const GetShipperStrikePrices = (props: GetShipperStrikePricesProps) => (
  <Get<ShipperStrikePricesResponse, unknown, GetShipperStrikePricesQueryParams, void>
    path='/v9/shipper_strike_prices'
    {...props}
  />
)

export type UseGetShipperStrikePricesProps = Omit<
  UseGetProps<ShipperStrikePricesResponse, unknown, GetShipperStrikePricesQueryParams, void>,
  'path'
>

/**
 * Get all shipper strike price data
 */
export const useGetShipperStrikePrices = (props: UseGetShipperStrikePricesProps) =>
  useGet<ShipperStrikePricesResponse, unknown, GetShipperStrikePricesQueryParams, void>(
    `/v9/shipper_strike_prices`,
    props
  )
